import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class TextAreaInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        // console.log(target.value)
        let value = (target.validity.valid) ? target.value : null
        if (value == '') {
            value = null
        }
        // console.log(value)
        this.props.changeValue(this.props.header.key, value, this.props.extra)

    }

    init = () => {
        // console.log("TEST")
    }


    render() {
        return (
            <div className="w-100 h-100">
                <textarea className="w-100 text-area-input" rows={this.props.header.information.rows} ref={el => this.input = el} value={this.props.data ? this.props.data : ''} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} disabled={this.props.header.information?.disabled} style={{ resize: "vertical", background: "transparent" }} />
            </div>
        )
    }
}

export default (TextAreaInput);